import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import styles from './appFallback.module.scss';
/**
 * A component that presents a fallback for when the app catches an error in the
 * error boundary.
 */
export const AppFallback = () => {
    /** Handles reloading of the app. */
    const handleAppReload = () => {
        window.location.reload();
    };
    return (_jsxs(FlexBox, Object.assign({ className: styles.root, justifyContent: "center", alignItems: "center", flexDirection: "column" }, { children: [_jsx(Text.Heading, Object.assign({ className: styles.heading }, { children: "Something went wrong." })), _jsx(Button, Object.assign({ onClick: handleAppReload }, { children: "Try reloading" }))] })));
};
